export enum BulkImportDocumentMetadataType {
  Summary = 'Summary',
  Upload = 'Upload',
}
